import { render, staticRenderFns } from "./MuSpNa.vue?vue&type=template&id=93000fb4"
import script from "./MuSpNa.vue?vue&type=script&lang=js"
export * from "./MuSpNa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports